import {
  GET_VEHICLE_MAKE_COUNT,
  SEARCH_VEHICLE,
  GET_PRODUCTS,
  GET_COUNTRIES,
  GET_SPECIFICATIONS,
  GET_PRICE,
  ADD_PRODUCT_TO_BASKET,
  // GET_BEST_DEALS,
  GET_PROMOTIONAL_API_DATA,
  GET_VEHICLE, SEARCH_ITEM,
  GET_STOCK_RECORD, GET_SHIPPING_METHODS, PLACE_ORDER, GET_ITEM, GET_ALL_PRODUCTS,
  GET_FOOTER_API_DATA, GET_CATEGORIES_API_DATA, GET_ARTICLES_DATA,
  GET_AI_REPORT, GET_SPORTS_DATA, GET_HPI_PRICE
} from "../constants";
import { Observable } from "rxjs/Rx";
import { vehicleAction} from "../actions/index";
import { HttpService } from "../../services/http";
import path from "../../config/path";

export default class vehicleEpic {
  // Get Vehicle Make Count
  static getVehicleMakeCount = action$ =>
    action$.ofType(GET_VEHICLE_MAKE_COUNT).switchMap(() => {
      return HttpService.get(`${path.VEHICLE_MAKE_COUNT}`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getVehicleMakeCountSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(
            vehicleAction.getVehicleMakeCountFailure(`${err}`)
          );
        });
    });

  // static getSportsData = action$ =>
  //   action$.ofType(GET_SPORTS_DATA).switchMap(() => {
  //     return HttpService.get(`${path.GET_SPORTS_DATA}`)
  //       .switchMap(response => {
  //         if (response.status === 200) {
  //           return Observable.of(
  //             vehicleAction.getSportsDataSuccess(response.response)
  //           );
  //         }
  //       })
  //       .catch(err => {
  //         return Observable.of(
  //           vehicleAction.getSportsDataFailure(`${err}`)
  //         );
  //       });
  //   });

static getSportsData = action$ =>
  action$.ofType(GET_SPORTS_DATA).switchMap(() => {
    return Observable.create(observer => {
      const es = new EventSource(path.GET_SPORTS_DATA);

      // Named event from backend
      es.addEventListener("sports_delta", (evt) => {
        try {
          const data = JSON.parse(evt.data);
          observer.next(vehicleAction.getSportsDataSuccess({
            ...data,
            _event_id: evt.lastEventId || null
          }));
        } catch (e) {
          observer.next(vehicleAction.getSportsDataFailure(e.message || "Parse error"));
        }
      });

      // Fallback if server sometimes sends default messages
      es.onmessage = (evt) => {
        try {
          const data = JSON.parse(evt.data);
          observer.next(vehicleAction.getSportsDataSuccess(data));
        } catch (e) {
          observer.next(vehicleAction.getSportsDataFailure(e.message || "Parse error"));
        }
      };

      // Do NOT complete the stream on transient errors
      es.onerror = (err) => {
        // Optional: surface soft error but keep connection alive
        observer.next(vehicleAction.getSportsDataFailure("SSE error (retrying)"));
        // EventSource will auto-reconnect; do not call observer.error(...)
      };

      // Teardown
      return () => es.close();
    })
    // already emitting actions, so no extra .map() needed
    .catch(err => Observable.of(
      vehicleAction.getSportsDataFailure(`Stream Error: ${err}`)
    ));
  });

  // Get AI Report
  static getAIReport = action$ =>
    action$.ofType(GET_AI_REPORT).switchMap(({ payload }) => {
      const payloadParameters = `?q=${payload}`
      return HttpService.get(`${path.GET_AI_REPORT}/${payloadParameters}`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getAIReportSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getAIReportFailure(`${err}`));
        });
    });


  // Search Vehicle
  static searchVehicle = action$ =>
    action$.ofType(SEARCH_VEHICLE).switchMap(({ payload }) => {
      const priceRange =
        payload.max - payload.min > 0
          ? `&price__range=${payload.min}__${payload.max}`
          : "";

      const order = payload.order === "0" ? "price" : "-price"
      let finalPayload = `?ordering=${order}&page=${payload.page}${priceRange}&search=${
        payload.st
      }&search_simple_query_string=${payload.sv}&title__wildcard=${
        payload.svm === "any" || payload.svm === "0"
          ? ""
          : payload.svm.toLowerCase()
      }`;


      return HttpService.get(`${path.SEARCH_VEHICLE}${finalPayload}`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.searchVehicleSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.searchVehicleFailure(`${err}`));
        });
    });

  // Search Item
  static searchItem = action$ =>
    action$.ofType(SEARCH_ITEM).switchMap(({ payload }) => {
      let payloadParameters = `?q=${payload.q}`
      if (payload.p) {
        payloadParameters += `&p=${payload.p}`;
      }
      if (payload.upc) {
        payloadParameters += `&upc=${payload.upc}`;
      }
      return HttpService.get(`${path.SEARCH_ITEM}/${payloadParameters}`)
        .switchMap(response=> {
          if (response.status === 200){
            return Observable.of(
              vehicleAction.searchItemSuccess(response.response)
            );
          }
          if (response.status === 204) {
            return Observable.of(
              vehicleAction.searchItemSuccess({status: 204})
            );
          }
        })
        .catch(err => {
          return Observable.of(
            vehicleAction.searchItemFailure(`${err}`));
        })
    })

  // Get HPI Price
  static getHPIPrice = action$ =>
    action$.ofType(GET_HPI_PRICE).switchMap(({ }) => {
      return HttpService.get(`${path.GET_HPI_PRICE}`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getHPIPriceSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getHPIPriceFailure(`${err}`));
        });
    });

  // Get Products
  static getProducts = action$ =>
    action$.ofType(GET_PRODUCTS).switchMap(({ payload }) => {
      return HttpService.get(`${path.GET_PRODUCTS}/${payload}`)
        .switchMap(response => {
          if (response.status === 200) {
             let priceURL = response.response.price
            if (process.env.REACT_APP_API_ENDPOINT === 'prod') {
              priceURL = priceURL.replace('http', 'https');
            }
            return Observable.of(
              vehicleAction.getProductsSuccess(response.response),
              vehicleAction.getCountries(payload),
              vehicleAction.getSpecifications(payload),
              vehicleAction.getPrice(priceURL)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getProductsFailure(`${err}`));
        });
    });

  // Get All Products
  static getAllProducts = action$ =>
    action$.ofType(GET_ALL_PRODUCTS).switchMap(({ payload }) => {
      let payloadParameters = `${path.GET_ALL_PRODUCTS}/?q=${payload}`
      return HttpService.get(payloadParameters)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getAllProductsSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getAllProductsFailure(`${err}`))
        });
  });


  // Get Countries
  static getCountries = action$ =>
    action$.ofType(GET_COUNTRIES).switchMap(() => {
      return HttpService.get(`${path.GET_COUNTRIES}/`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getCountriesSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getCountriesFailure(`${err}`));
        });
    });

  // Get Specifications
  static getSpecifications = action$ =>
    action$.ofType(GET_SPECIFICATIONS).switchMap(({ payload }) => {
      return HttpService.get(`${path.GET_SPECIFICATIONS}/${payload}`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getSpecificationsSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(
            vehicleAction.getSpecificationsFailure(`${err}`)
          );
        });
    });

  // Get Price
  static getPrice = action$ =>
    action$.ofType(GET_PRICE).switchMap(({ payload }) => {
      return HttpService.get(`${payload}`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getPriceSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getPriceFailure(`${err}`));
        });
    });

  // Get Stock Record
  static getStockRecord = action$ =>
    action$.ofType(GET_STOCK_RECORD).switchMap(({ payload }) => {
      return HttpService.get(`${payload}`)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getStockRecordSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getStockRecordFailure(`${err}`));
        });
    });

  // Add Product To Basket
  static addProductToBasket = action$ =>
    action$.ofType(ADD_PRODUCT_TO_BASKET).switchMap(({ payload }) => {
      const token = localStorage.getItem('token')
      return HttpService
        .post(path.ADD_PRODUCT_TO_BASKET, payload, {"Authorization": "Token "+ token})
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.addProductToBasketSuccess(response.response)
            );
          }
        })
        .catch(err => {
          if (err.response.reason === "Unavailable" ){
            return Observable.of(vehicleAction.addProductToBasketFailure("Item is unavailable"))
          }
          return Observable.of(
            vehicleAction.addProductToBasketFailure(`${err}`)
          );
        });
    });

  // Place Order
  static placeOrder = action$ =>
    action$.ofType(PLACE_ORDER).switchMap(({ payload }) => {
      if (!payload.guestCheckout) {
        return HttpService.post(path.PLACE_ORDER, payload.dataPayload, {"Authorization": "Token "+ payload.sessionToken})
          .switchMap(response => {
            if (response.status === 200 ) {
              return Observable.of(
                vehicleAction.placeOrderSuccess(response.response)
              );
            }
          })
          .catch(err => {
            return Observable.of(
              vehicleAction.placeOrderFailure(`${err}`)
            );
          });
      } else {
        return HttpService.post(path.PLACE_ORDER, payload.dataPayload )
          .switchMap(response => {
            if (response.status === 200 ) {
              return Observable.of(
                vehicleAction.placeOrderSuccess(response.response)
              );
            }
          })
          .catch(err => {
            return Observable.of(
              vehicleAction.placeOrderFailure(`${err}`)
            );
          });
      }
    });

  // Get Promotional Api Data
  static getPromotionalApiData = action$ =>
    action$.ofType(GET_PROMOTIONAL_API_DATA).switchMap(() => {
      return HttpService.get(path.GET_PROMOTIONAL_API_DATA)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getPromotionalApiDataSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(
            vehicleAction.getPromotionalApiDataFailure({ errMess: err })
          );
        });
    });

  // Get Footer Api Data
  static getFooterApiData = action$ =>
    action$.ofType(GET_FOOTER_API_DATA).switchMap(() => {
      return HttpService.get(path.GET_FOOTER_API_DATA)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
                vehicleAction.getFooterApiDataSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(
            vehicleAction.getFooterApiDataFailure({errMess: err})
          );
        });
      });

  static getCategoriesApiData = action$ =>
    action$.ofType(GET_CATEGORIES_API_DATA).switchMap(() => {
      return HttpService.get(path.GET_CATEGORIES_API_DATA)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
                vehicleAction.getCategoriesApiDataSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(
            vehicleAction.getCategoriesApiDataFailure({errMess: err})
          );
        });
      });

  // Get Shipping methods data
  static getShippingMethods = action$ =>
    action$.ofType(GET_SHIPPING_METHODS).switchMap(() => {
      return HttpService.get(path.GET_SHIPPING_METHODS)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getShippingMethodsSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(
            vehicleAction.getShippingMethodsFailure({ errMess: err })
          );
        });
    });

  // Get Articles Data
  static getArticlesData = action$ =>
    action$.ofType(GET_ARTICLES_DATA).switchMap(()=> {
      return HttpService.get(path.GET_ARTICLES)
        .switchMap(response => {
          if (response.status === 200) {
            return Observable.of(
              vehicleAction.getArticlesDataSuccess(response.response)
            )
          }
        })
        .catch( err => {
          return Observable.of(vehicleAction.getArticlesDataFailure(`${err}`));
        });
    })


  // Get Product Details
  static getVehicle = action$ =>
    action$.ofType(GET_VEHICLE).switchMap(({ payload }) => {
      return HttpService.get(`${path.GET_VEHICLE_DETAILS}/${payload}/`)
        .switchMap(response => {
          if (response.status === 200) {
            let priceURL = response.response.price
            let stockURL = response.response.stockrecords
            if (process.env.REACT_APP_API_ENDPOINT === 'prod' || process.env.REACT_APP_API_ENDPOINT === 'staging') {
              priceURL = priceURL.replace('http', 'https');
              stockURL = stockURL.replace('http', 'https');
            }
            return Observable.of(
              vehicleAction.getVehicleSuccess(response.response),
              vehicleAction.getPrice(priceURL),
              vehicleAction.getStockRecord(stockURL)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getVehicleFailed(`${err}`));
        });
    })

    // Get Item Details
  static getItem = action$ =>
    action$.ofType(GET_ITEM).switchMap(({ payload }) => {
      let payloadParameters = `?q=${payload}&type=gsi`
      return HttpService.get(`${path.SEARCH_ITEM}/${payloadParameters}`)
        .switchMap(response=> {
          if (response.status === 200){
            return Observable.of(
              vehicleAction.getItemSuccess(response.response)
            );
          }
        })
        .catch(err => {
          return Observable.of(vehicleAction.getItemFailure(`${err}`));
        })
    })
}
